var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlash = function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22253B",
    d: "m20.049 11.762-10.5 11.25a.75.75 0 0 1-1.284-.656L9.64 15.48l-5.403-2.029a.75.75 0 0 1-.282-1.219l10.5-11.25a.75.75 0 0 1 1.284.657L14.36 8.522l5.403 2.026a.75.75 0 0 1 .28 1.214z"
  })));
};
export default SvgFlash;